/**
 * PreferencesCard — the "Theme" section in the unified Profile card.
 *
 * Renders just the section content (header + compact theme picker).
 * The route owns the outer Card.
 *
 * Uses `<ThemePreviewPicker size="compact">` so the tiles read as a
 * row of swatches rather than hero previews — the broader Profile card
 * already gives this section its visual weight via the hairline
 * dividers above and below.
 */
import { ThemePreviewPicker } from "./theme-preview-picker.tsx";

export function PreferencesCard() {
  return (
    <section className="px-5 sm:px-6 py-5 sm:py-6 flex flex-col gap-4">
      <header>
        <h2 className="text-sm font-semibold text-ink uppercase tracking-wider">Theme</h2>
        <p className="text-sm text-muted mt-1">
          Choose how Flint looks. Saved per device — picking dark on phone won&apos;t darken your
          laptop.
        </p>
      </header>

      <ThemePreviewPicker size="compact" />
    </section>
  );
}
